module.exports = __webpack_public_path__ + "img/ex2.b714cbf6.png";